import type { ComponentProps } from 'react';

import { cn, getColoredCellStyle } from '../../lib/utils';

type ColoredCellProps = Omit<ComponentProps<'div'>, 'color'> & {
  color: string;
};

/**
 * A colour-filled cell that automatically applies an accessible text colour
 * for the supplied background. Layout (size, radius, padding) is supplied by
 * the caller via `className`. Used across the rating family for coloured
 * headers, labels, and matrix cells.
 */
function ColoredCell({ color, className, style, ...props }: ColoredCellProps) {
  return (
    <div
      data-slot={'colored-cell'}
      className={cn('flex items-center justify-center rounded-lg', className)}
      style={{ ...getColoredCellStyle(color), ...style }}
      {...props}
    />
  );
}

export { ColoredCell };
export type { ColoredCellProps };
